import { Controller } from '@hotwired/stimulus'
import UserPreferences from 'models/user_preferences'

export default class extends Controller {
  initialize() {
    const params = new URLSearchParams(document.location.search.substring(1))
    const autoplay = params.get("autoplay")
    const { autoplayPreference, videoId, redirectAfterPlayUrl } = this.element.dataset
    const preferences = new UserPreferences()

    window._wq = window._wq || []

    _wq.push({ id: videoId, onReady: async (video) => {
      video.bind("end", async () => {
        const value = await preferences.get(autoplayPreference)
        if (value && redirectAfterPlayUrl) {
          window.location.href = redirectAfterPlayUrl
        }
      })

      const value = await preferences.get(autoplayPreference)
      if (value || autoplay === "true") {
        video.play()
      }
    }})
  }
}
